import { MessageStatus } from "../proto"

const text: { [key in MessageStatus]: string } = {
  [MessageStatus.SENDING]: "发送中",
  [MessageStatus.SENT]: "已发送",
  [MessageStatus.DELIVERED]: "未读", // 已接收未读
  [MessageStatus.READ]: "已读",
  [MessageStatus.FAILED]: "失败",
  [MessageStatus.UPLOADING]: "上传中",
  [MessageStatus.DOWNLOADING]: "下载中",
  [MessageStatus.ORDER]: ""
}

export const messageStatusText = (s: MessageStatus) => {
  return text[s]
}

export enum NotifyType {
  CONTACT_CREATED = 1, // 创建联系人
  CONTACT_DELETED = 2, // 删除联系人
  GROUP_TITLE_UPDATE = 3, // 群名称被修改
  CHAT_CREATED = 4, // 创建聊天
  CHAT_MEMBER_ADDED = 5, // 聊天成员被添加
  CHAT_MEMBER_REMOVED = 6, // 聊天成员被移除
  CHAT_MEMBER_LEFT = 7, // 聊天成员退出
  CONTACT_CREATED_BUT_NOT_APPROVED = 8, // 创建联系人但未通过
  MESSAGE_CREATED_BUT_NOT_APPROVED = 9, // 创建消息但未通过
  FRIEND_ADDED_BUT_NOT_APPROVED = 10, // 添加好友但未通过
  CHAT_BURNING_TIMER_SWITCHED = 11, // 群聊阅后即焚设置被修改
  CHAT_ANNOUNCEMENTED = 12, // 群公告被修改
}
